<div class="bg-white min-h-screen p-6">
  <!-- Message de succès -->
  <div *ngIf="showSuccessMessage"
    class="fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50">
    <i class="fa-solid fa-check-circle mr-2"></i>
    {{ successMessage }}
  </div>

  <!-- Message d'erreur -->
  <div *ngIf="error" class="fixed top-4 right-4 bg-red-500 text-white px-6 py-3 rounded-lg shadow-lg z-50">
    <i class="fa-solid fa-exclamation-triangle mr-2"></i>
    {{ error }}
    <button (click)="error = null" class="ml-3 text-white hover:text-gray-200">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>

  <!-- Navigation principale -->
  <div class="bg-white rounded-lg shadow-sm mb-6">
    <!-- Sous-navigation entre Albums, Graphique, Tableau -->
    <div class="flex bg-[#F5F7FA] px-6 p-[8px] rounded[8px]">
      <button (click)="setActiveTab('albums')"
        [ngClass]="activeTab === 'albums' ? 'text-orange-500 border-b-2 border-orange-500 bg-white font-medium' : 'text-gray-600 hover:text-gray-800'"
        class="py-4 px-4 w-2/6 rounded-[4px]">
        {{ t('statusReport.albumsView') }}
      </button>
      <button (click)="setActiveTab('graphique')"
        [ngClass]="activeTab === 'graphique' ? 'text-orange-500 border-b-2 border-orange-500 bg-white font-medium' : 'text-gray-600 hover:text-gray-800'"
        class="py-4 px-4 w-2/6 rounded-[4px]">
        {{ t('statusReport.graphView') }}
      </button>
      <button (click)="setActiveTab('tableau')"
        [ngClass]="activeTab === 'tableau' ? 'text-orange-500 border-b-2 border-orange-500 bg-white font-medium' : 'text-gray-600 hover:text-gray-800'"
        class="py-4 px-4 w-2/6 rounded-[4px]">
        {{ t('statusReport.indicatorsTable') }}
      </button>
    </div>
  </div>

  <!-- Contenu Vue Albums -->
  <div *ngIf="activeTab === 'albums'" class="p-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

      <!-- Cartes albums normales avec hover actions -->
      <div *ngFor="let album of albums"
        class="group relative rounded-xl overflow-hidden shadow-md bg-white cursor-pointer">

        <!-- Overlay actions (apparaît au hover) -->
        <div
          class="absolute inset-0 bg-black/60 flex items-center justify-center gap-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
          <button
            (click)="album.pictures && album.pictures.length > 0 && openImageViewer(album.pictures[0], album.pictures); $event.stopPropagation()"
            class="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center text-white hover:bg-white/30 hover:scale-110 transition-all duration-200 border border-white/30"
            [title]="t('statusReport.viewPhotos')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          </button>

          <button (click)="onEditAlbum(album); $event.stopPropagation()"
            class="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center text-white hover:bg-white/30 hover:scale-110 transition-all duration-200 border border-white/30"
            [title]="t('statusReport.editAlbum')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </button>

          <button (click)="onDeleteAlbum(album); $event.stopPropagation()"
            class="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center text-white hover:bg-red-500/70 hover:scale-110 transition-all duration-200 border border-white/30"
            [title]="t('statusReport.deleteAlbum')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
          </button>
        </div>

        <!-- Contenu de la carte -->
        <img [src]="getBaseFile() + (album?.pictures?.[0] || 'default-placeholder.jpg')" alt="{{ album.phaseName }}"
          class="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
          (error)="handleImageError($event, album)" />

        <div class="p-4 bg-white">
          <h3 class="text-lg font-semibold mb-2 text-gray-800">{{ album.phaseName }}</h3>
          <div class="flex items-center text-gray-500 text-sm space-x-4">
            <div class="flex items-center gap-1">
              <i class="fa-solid fa-calendar-days text-sm"></i>
              <span>{{ formatDate(album.lastUpdated) }}</span>
            </div>
            <div class="flex items-center gap-1">
              <i class="fa-solid fa-image text-sm"></i>
              <span>{{ getPhotoCount(album.pictures) }} {{ t('statusReport.photos') }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Contenu Vue Graphique -->
  <div *ngIf="activeTab === 'graphique'" class="bg-white p-4 rounded-lg shadow">
    <div class="flex justify-center">
      <div class="w-full md:w-4/5">
        <app-progess-report></app-progess-report>
      </div>
    </div>
  </div>

  <!-- Contenu Vue Tableau indicateurs -->
  <div *ngIf="activeTab === 'tableau'" class="bg-white p-4 rounded-lg shadow">

    <!-- Composant progress-report caché pour récupérer les données -->
    <div style="display: none;">
      <app-progess-report #progressReport [title]="'État d\'avancement'" [chartId]="'hiddenProgressChart'">
      </app-progess-report>
    </div>

    <div class="bg-white p-6 rounded-lg shadow-md">
      <div class="overflow-x-auto">
        <table class="min-w-full text-left text-sm">
          <thead class="bg-[#F5F7FA]">
            <tr>
              <th class="py-4 px-6 font-semibold text-gray-800 text-base">{{ t('statusReport.step') }}</th>
              <th class="py-4 px-6 font-semibold text-gray-800 text-base">{{ t('statusReport.percentage') }}</th>
              <th class="py-4 px-6 font-semibold text-gray-800 text-base">{{ t('statusReport.updateDate') }}</th>
            </tr>
          </thead>
          <tbody class="text-gray-700">
            <tr *ngFor="let ligne of lignes; let i = index"
              class="border-b border-gray-100 hover:bg-gray-50 transition-colors">
              <!-- Colonne Étape -->
              <td class="py-6 px-6">
                <span class="text-base font-medium text-gray-800">{{ ligne.etape }}</span>
              </td>

              <!-- Colonne %Pourcentage avec Select -->
              <td class="py-6 px-6">
                <div class="relative">
                  <!-- Indicateur de chargement -->
                  <div *ngIf="isUpdating(ligne.etape)"
                    class="absolute inset-0 bg-white/80 flex items-center justify-center rounded-md z-10">
                    <svg class="animate-spin h-5 w-5 text-orange-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                      </path>
                    </svg>
                  </div>

                  <!-- Select personnalisé -->
                  <div class="relative">
                    <select [ngModel]="getProgressValue(ligne.etape) > 0 ? getProgressValue(ligne.etape) + '%' : ''"
                      (change)="onPercentageChange(ligne.etape, $event)" [disabled]="isUpdating(ligne.etape)"
                      class="w-[357px] h-[40px] appearance-none border border-[#CBD5E1] rounded-[5px] px-3 py-2.5 pr-10 text-sm font-normal text-center focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                      [ngClass]="{
                      'text-gray-400': getProgressValue(ligne.etape) === 0,
                      'text-gray-800': getProgressValue(ligne.etape) > 0
                    }" style="font-family: Inter; font-size: 14px; line-height: 100%;">

                      <!-- Option par défaut si aucun pourcentage -->
                      <option value="" [selected]="getProgressValue(ligne.etape) === 0" disabled>
                        {{ t('statusReport.selectPercentage') }}
                      </option>

                      <!-- Options des pourcentages -->
                      <option *ngFor="let pct of pourcentages" [value]="pct"
                        [selected]="getProgressValue(ligne.etape) + '%' === pct">
                        {{ pct }}
                      </option>
                    </select>

                    <!-- Icône flèche dropdown personnalisée -->
                    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </td>

              <!-- Colonne Date -->
              <td class="py-6 px-6">
                <span class="text-base text-gray-600">
                  {{ getProgressDate(ligne.etape) || getCurrentDate() }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Message d'erreur si présent -->
        <div *ngIf="error" class="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3">
          <svg class="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"></path>
          </svg>
          <div class="flex-1">
            <p class="text-red-700 text-sm font-medium">{{ error }}</p>
            <button (click)="error = null" class="mt-2 text-red-600 hover:text-red-800 text-xs font-medium underline">
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Créer Album -->
<div *ngIf="showCreateModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <h2 class="text-xl font-bold mb-4">{{ t('statusReport.createAlbum') }}</h2>

    <form (ngSubmit)="createAlbum()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nom de l'album *</label>
        <input type="text" [(ngModel)]="albumForm.name" name="name" required
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          placeholder="Nom de l'album">
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Description</label>
        <textarea [(ngModel)]="albumForm.description" name="description" rows="3"
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          placeholder="Description de l'album"></textarea>
      </div>

      <!-- Section d'ajout de photos -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('statusReport.albumPhotos') }}</label>

        <!-- Input pour upload de fichiers -->
        <div class="border-2 border-dashed border-gray-300 rounded-md p-4 text-center">
          <input type="file" id="albumPhotos" multiple accept="image/*" (change)="onFileSelected($event)"
            class="hidden">

          <label for="albumPhotos" class="cursor-pointer">
            <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
              </path>
            </svg>
            <p class="mt-1 text-sm text-gray-600">
              {{ t('statusReport.clickToAdd') }}
            </p>
            <p class="text-xs text-gray-500">
              {{ t('statusReport.acceptedFormats') }}
            </p>
          </label>
        </div>

        <!-- Aperçu des photos sélectionnées -->
        <div *ngIf="albumForm.pictures.length > 0" class="mt-3">
          <p class="text-sm font-medium text-gray-700 mb-2">
            {{ t('statusReport.selectedPhotos') }} ({{ albumForm.pictures.length }})
          </p>
          <div class="grid grid-cols-3 gap-2">
            <div *ngFor="let picture of albumForm.pictures; let i = index" class="relative">
              <img [src]="picture" class="w-full h-20 object-cover rounded-md">
              <button type="button" (click)="removePicture(i)"
                class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                title="Supprimer">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-3 pt-4">
        <button type="button" (click)="closeCreateModal()"
          class="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded-md">
          {{ t('statusReport.cancel') }}
        </button>
        <button type="submit" [disabled]="!albumForm.name.trim()"
          class="flex-1 bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-md disabled:opacity-50 disabled:cursor-not-allowed">
          {{ t('statusReport.create') }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- ============================================ -->
<!-- PARTIE 1: Modal Modifier Album (CORRIGÉ) -->
<!-- ============================================ -->
<div *ngIf="showEditModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
    <h2 class="text-xl font-bold mb-4">{{ t('statusReport.editAlbum') }}</h2>

    <form (ngSubmit)="updateAlbum()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('statusReport.albumName') }} *</label>
        <input type="text" [(ngModel)]="albumForm.name" name="name" required
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          [placeholder]="t('statusReport.albumName')">
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Description</label>
        <textarea [(ngModel)]="albumForm.description" name="description" rows="3"
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          placeholder="Description de l'album"></textarea>
      </div>

      <!-- NOUVEAU: Section de gestion des photos -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('statusReport.albumPhotos') }}</label>

        <!-- Photos existantes -->
        <div *ngIf="albumForm.pictures.length > 0" class="mb-3">
          <p class="text-sm text-gray-600 mb-2">
            {{ t('statusReport.currentPhotos') }} ({{ albumForm.pictures.length }})
          </p>
          <div class="grid grid-cols-3 gap-2">
            <div *ngFor="let picture of albumForm.pictures; let i = index" class="relative">
              <img [src]="picture.startsWith('data:') ? picture : getBaseFile() + picture"
                class="w-full h-20 object-cover rounded-md border border-gray-300">
              <button type="button" (click)="removePicture(i)"
                class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 shadow-md"
                title="Supprimer cette photo">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Input pour ajouter de nouvelles photos -->
        <div class="border-2 border-dashed border-gray-300 rounded-md p-4 text-center">
          <input type="file" id="editAlbumPhotos" multiple accept="image/*" (change)="onEditFileSelected($event)"
            class="hidden">

          <label for="editAlbumPhotos" class="cursor-pointer">
            <svg class="mx-auto h-10 w-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
            <p class="mt-1 text-sm text-gray-600">
              {{ t('statusReport.addNewPhotos') }}
            </p>
            <p class="text-xs text-gray-500">
              {{ t('statusReport.acceptedFormats') }}
            </p>
          </label>
        </div>
      </div>

      <div class="flex gap-3 pt-4">
        <button type="button" (click)="closeEditModal()"
          class="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded-md transition-colors">
          {{ t('statusReport.cancel') }}
        </button>
        <button type="submit" [disabled]="!albumForm.name.trim()"
          class="flex-1 bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          {{ t('statusReport.modify') }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Modal Confirmation Suppression -->
<div *ngIf="showDeleteModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <div class="text-center">
      <i class="fa-solid fa-exclamation-triangle text-red-500 text-4xl mb-4"></i>
      <h2 class="text-xl font-bold mb-4">{{ t('statusReport.confirmDeletion') }}</h2>
      <p class="text-gray-600 mb-6">
        {{ t('statusReport.deleteConfirmMessage') }}
        <strong>"{{ albumToDelete?.phaseName }}"</strong> ?
        <br>
        {{ t('statusReport.irreversibleAction') }}
      </p>

      <div class="flex gap-3">
        <button (click)="closeDeleteModal()"
          class="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded-md">
          {{ t('statusReport.noCancel') }}
        </button>
        <button (click)="confirmDelete()" class="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md">
          {{ t('statusReport.yesDelete') }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Voir Album -->
<div *ngIf="showViewModal && currentAlbum"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
    <!-- Header -->
    <div class="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-bold text-gray-800">{{ currentAlbum.phaseName }}</h2>
        <p class="text-gray-600 text-sm mt-1">{{ formatDate(currentAlbum.lastUpdated) }} • {{
          getPhotoCount(currentAlbum.pictures) }} photos</p>
      </div>
      <button (click)="closeViewModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Galerie de photos -->
    <div class="p-6">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div *ngFor="let picture of currentAlbum.pictures; let i = index"
          (click)="openImageViewer(picture, currentAlbum.pictures)"
          class="relative group cursor-pointer rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
          <img [src]="getBaseFile() + picture" [alt]="'Photo ' + (i + 1)"
            class="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110">

          <!-- Hover Overlay with magnify icon -->
          <div
            class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
            <svg class="w-12 h-12 text-white transform scale-75 group-hover:scale-100 transition-transform duration-300"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Message si pas de photos -->
      <div *ngIf="!currentAlbum.pictures || currentAlbum.pictures.length === 0" class="text-center py-12 text-gray-500">
        <i class="fa-solid fa-images text-4xl mb-3"></i>
        <p>{{ t('statusReport.noPhotos') }}</p>
      </div>
    </div>
  </div>
</div>

<!-- ========== VISIONNEUSE D'IMAGES PLEIN ÉCRAN ========== -->
<div *ngIf="selectedImage" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90"
  (click)="closeImageViewer()">

  <div class="relative max-w-7xl w-full h-full flex flex-col items-center justify-center"
    (click)="$event.stopPropagation()">

    <!-- Close Button -->
    <button (click)="closeImageViewer()"
      class="absolute top-4 right-4 text-white hover:text-gray-300 z-50 p-2 rounded-full hover:bg-white/10 transition-colors">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <!-- Main Image -->
    <div class="relative w-full h-full flex items-center justify-center overflow-hidden">
      <img [src]="getBaseFile() + selectedImage" class="max-h-[85vh] max-w-full object-contain rounded-lg shadow-2xl"
        [alt]="'Photo album'">

      <!-- Navigation Buttons -->
      <button *ngIf="currentAlbumImages.length > 1" (click)="previousImage()"
        class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors backdrop-blur-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <button *ngIf="currentAlbumImages.length > 1" (click)="nextImage()"
        class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors backdrop-blur-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    <!-- Image Counter & Thumbnails -->
    <div class="mt-4 text-white text-center">
      <p class="text-sm opacity-80 mb-2">{{ currentImageIndex + 1 }} / {{ currentAlbumImages.length }}</p>

      <!-- Thumbnails -->
      <div class="flex gap-2 justify-center overflow-x-auto pb-2 max-w-full" *ngIf="currentAlbumImages.length > 1">
        <div *ngFor="let img of currentAlbumImages; let i = index" (click)="selectImageIndex(i)"
          class="w-16 h-16 rounded overflow-hidden cursor-pointer border-2 transition-all flex-shrink-0"
          [class.border-orange-500]="i === currentImageIndex" [class.border-transparent]="i !== currentImageIndex">
          <img [src]="getBaseFile() + img" class="w-full h-full object-cover">
        </div>
      </div>
    </div>

  </div>
</div>